import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useNavigate, useParams } from "react-router-dom";
import { GET_ALL_FEE_PLAN } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";

const useRevenueManager = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const { mutate: createFeePlan } = useMutation({
    mutationKey: ["CREATE_FEE_PLAN"],
    mutationFn: (data) => axiosInstance.post("/api/revenue/fee-plan/", data),
    onSuccess: () => {
      navigate(-1);
    },
  });

  const {
    data: getFeePlanById,
    isFetching: getFeePlanFetching,
    isFetched: getFeePlanFetched,
  } = useFetchQuery({
    key: ["GET_FEE_PLAN_BY_ID"],
    route: `/api/revenue/fee-plan/${id}/`,
    enabled: Boolean(id),
  });

  const { mutate: updateFeePlan, isLoading: updateFeePlanLoading } =
    useMutation({
      mutationKey: ["UPDATE_FEE_PLAN"],
      mutationFn: (data) =>
        axiosInstance.patch(`/api/revenue/fee-plan/${id}/`, data),
      onSuccess: () => {
        navigate(-1);
      },
    });

  const { data: feePlansList, isFetching: getFeePlansFetching } = useFetchQuery(
    {
      key: ["GET_FEE_PLANS_DROPDOWN"],
      route: GET_ALL_FEE_PLAN,
    },
  );

  return {
    createFeePlan,
    getFeePlanById,
    getFeePlanFetching,
    updateFeePlan,
    getFeePlanFetched,
    feePlansList,
    getFeePlansFetching,
    updateFeePlanLoading,
  };
};

export default useRevenueManager;
